<template>
  <page-wrapper :title="title" :has-pad="true">
    <div class="wrapper">
      <package-tier-editor
        v-model="form"
        :disabled="$isCallCenter"
      ></package-tier-editor>
      <div v-if="!$isCallCenter" class="text-end">
        <sc-button variant="primary" @click="handleClickSave">บันทึก</sc-button>
      </div>
    </div>
  </page-wrapper>
</template>

<script>
import PageWrapper from "@/lib/components/PageWrapper"
import ScButton from "@/lib/components/ScButton"
import { baanRueJaiClient } from "@/dependencies"
import { toCamelCaseObject } from "@/lib/util"
import PackageTierEditor from "../components/PackageTierEditor"

export default {
  components: {
    PageWrapper,
    ScButton,
    PackageTierEditor,
  },
  data() {
    const title = "รายละเอียด Tier"
    const form = {
      name: "",
      packages: [],
    }

    const packages = []

    return {
      title,
      form,
      packages,
    }
  },
  created() {
    this.setup()
  },
  methods: {
    async setup() {
      await this.setupData()
    },
    setupData() {
      this.setupTier()
    },
    async setupTier() {
      const { name, packages } = await this.fetchData()

      this.form = {
        ...this.form,
        name,
        packages: packages ? toCamelCaseObject(packages) : [],
      }
    },
    async fetchData() {
      const { id } = this.$route.params
      const response = await baanRueJaiClient.admin.ruejaiClub.tiers.get(id)

      return response.data.result
    },
    async handleClickSave() {
      // eslint-disable-next-line no-alert
      if (!window.confirm("ยืนยันการบันทึก")) {
        return
      }

      try {
        await this.update()
        this.$router.push({ name: "RuejaiClubTierListPage" })
      } catch (err) {
        this.$message.error("เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง")
        // eslint-disable-next-line no-console
        console.error(err)
      }
    },
    async update() {
      const { id } = this.$route.params
      const params = await this.getUpdateParams()

      const response = await baanRueJaiClient.admin.ruejaiClub.tiers.put(
        id,
        params,
      )

      return response.data.result
    },
    async getUpdateParams() {
      const { name, packages } = this.form

      /* eslint-disable camelcase -- API payload */
      const package_ids = packages.map((item) => item.id)

      const params = { name, package_ids }
      /* eslint-enable camelcase */

      return params
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.wrapper {
  padding: $space 0;
}

.editor {
  margin-bottom: $space;
}

.btn-remove {
  float: left;
}
</style>
